export default __webpack_public_path__ + "static/media/Audience-Designer-Toolbox_White2.b293e761.svg";